




import Vue from 'vue';

export default Vue.extend({
  created() {
    if (this.$store.getters.refreshToken) {
      this.$router.push('/home');
    } else {
      this.$router.push('/demo');
    }
  },
});
